import withInteractor from "./SignInBlock.interactor";
import withPresenter from "./SignInBlock.presenter";
import SignInBlockView from "./SignInBlock.view";

export default withInteractor(withPresenter(SignInBlockView));
